import { getDataFromSS, isEditedContract } from '@/utils'

const contract = getDataFromSS('creatingContract', {})

export const state = {
  contract: {
    active: isEditedContract(contract)
  },
  myTasks: false,
  contractTasks: false
}

export const mutations = {
  SET_ACTIVE_TASK_STATE (state, { type, value }) {
    state[type].active = value
  },
  SET_TASKS_FLAG (state, { type, value }) {
    state[type] = value
  }
}

export default {
  state,
  mutations
}
